import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, fmtDate, fmtQty } from "../../api";
import { Plus } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import StatusBadge from "../../components/StatusBadge";

export default function PackingLists() {
  const [pls, setPls] = useState(null);
  const [search, setSearch] = useState("");
  const { user } = useAuth();
  const navigate = useNavigate();
  const canCreate = ["admin", "packing"].includes(user?.role);

  useEffect(() => {
    api.get("/packing-lists", { params: { search } }).then((r) => setPls(r.data)).catch(() => {});
  }, [search]);

  return (
    <div data-testid="packing-lists-page" className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-heading text-3xl font-extrabold text-[#002B5D] tracking-tight">Packing Lists</h1>
        {canCreate && (
          <Link to="/packing-list/new" data-testid="new-packing-list-button"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-md font-heading font-bold text-sm text-white" style={{ backgroundColor: "#EB1C27" }}>
            <Plus className="w-4 h-4" /> Create Packing List
          </Link>
        )}
      </div>
      <input data-testid="pl-search-input" placeholder="Search PL number, customer, lot..." value={search} onChange={(e) => setSearch(e.target.value)} className="sk-input max-w-xs" />
      <div className="sk-card overflow-x-auto">
        <table className="w-full sk-table" data-testid="pl-table">
          <thead><tr><th>Packing List</th><th>Date</th><th>Customer</th><th>Invoice</th><th className="text-right">Total Qty</th><th className="text-right">Items</th><th>Status</th><th>Shipped</th><th>Shipped By</th></tr></thead>
          <tbody>
            {!pls && <tr><td colSpan={9} className="text-center text-slate-400">Loading...</td></tr>}
            {pls?.length === 0 && <tr><td colSpan={9} className="text-center text-slate-400">No packing lists yet</td></tr>}
            {pls?.map((p) => (
              <tr key={p.id} className="cursor-pointer" onClick={() => navigate(`/packing-list/${p.id}`)} data-testid={`pl-row-${p.pl_number}`}>
                <td className="font-mono font-semibold text-[#002B5D]">{p.pl_number}</td>
                <td className="text-slate-500">{fmtDate(p.date)}</td>
                <td>{p.customer || "-"}</td>
                <td className="font-mono text-xs">{p.invoice_number || "-"}</td>
                <td className="text-right font-mono font-semibold">{fmtQty(p.total_qty)}</td>
                <td className="text-right font-mono">{(p.items || []).length}</td>
                <td><StatusBadge status={p.status || "Created"} testid={`pl-status-${p.pl_number}`} /></td>
                <td className="text-slate-500 text-xs">{p.shipped_at ? fmtDate(p.shipped_at) : "-"}</td>
                <td className="text-slate-500 text-xs">{p.shipped_by || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
